import IWidget from '../widget/iwidget.js';

export class WidgetException extends Error {
    public widget: IWidget;

    public reason: string;

    public severity: string;

    constructor(widget: IWidget, reason = '', severity = '') {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(reason);

        this.widget = widget;
        this.reason = reason;
        this.severity = severity;
    }
}
